var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.565 12.2545H17.4988V13.2876C17.4988 13.5616 17.6077 13.8243 17.8014 14.0181C17.9952 14.2118 18.2579 14.3207 18.5319 14.3207C18.8059 14.3207 19.0687 14.2118 19.2625 14.0181C19.4562 13.8243 19.565 13.5616 19.565 13.2876V12.2545Z",
    fill: "#04758E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3333 8.12195V10.1882H13.3664V13.2875C13.3664 14.6574 13.9106 15.9713 14.8794 16.94C15.8481 17.9088 17.162 18.453 18.5319 18.453C17.162 18.453 15.8481 18.9972 14.8794 19.9659C13.9106 20.9346 13.3664 22.2485 13.3664 23.6185V26.7178H12.3333V28.784H24.7305V26.7178H23.6974V23.6185C23.6974 22.2485 23.1532 20.9346 22.1845 19.9659C21.2158 18.9972 19.9019 18.453 18.5319 18.453C19.2103 18.453 19.882 18.3194 20.5087 18.0598C21.1354 17.8002 21.7048 17.4197 22.1845 16.94C22.6642 16.4604 23.0447 15.8909 23.3042 15.2642C23.5638 14.6375 23.6974 13.9658 23.6974 13.2875V10.1882H24.7305V8.12195H12.3333ZM15.4326 10.1882H21.6312V13.2875C21.6312 14.1095 21.3047 14.8978 20.7235 15.479C20.1422 16.0602 19.3539 16.3868 18.5319 16.3868C17.7099 16.3868 16.9216 16.0602 16.3404 15.479C15.7592 14.8978 15.4326 14.1095 15.4326 13.2875V10.1882ZM15.4326 23.6185V26.7178H21.6312V23.6185C21.6312 22.7965 21.3047 22.0082 20.7235 21.427C20.1422 20.8457 19.3539 20.5192 18.5319 20.5192C17.7099 20.5192 16.9216 20.8457 16.3404 21.427C15.7592 22.0082 15.4326 22.7965 15.4326 23.6185Z",
    fill: "#04758E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg2.db2c6697c3fa67c1c08e5acedcb7f4f3.svg";
export { ForwardRef as ReactComponent };